import { render } from "./CustomerProductProperties.vue?vue&type=template&id=52bfd955&scoped=true&ts=true"
import script from "./CustomerProductProperties.vue?vue&type=script&lang=ts"
export * from "./CustomerProductProperties.vue?vue&type=script&lang=ts"

import "./CustomerProductProperties.vue?vue&type=style&index=0&id=52bfd955&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bfd955"]])

export default __exports__